import React, { useEffect, useState } from "react";
import { getUserDetails } from "../../lib/api";
import { Link, useNavigate, useParams } from "react-router-dom";
import { cn, dateConvert } from "../../shared/utils";
import { format, parseISO } from "date-fns";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { useStore } from "../../store";
export const DoctorDetail = (props) => {
  const setSelectedAppointment = useStore((state) => state.setAppointment);
  const selectedAppointment = useStore((state) => state.selectedAppointment);

  const [isLoading, setIsLoading] = useState(true);
  const [userDetails, setUserDetails] = useState(null);
  const { doctorId: id } = useParams();

  const [selectedLocation, setSelectedLocation] = useState("");
  const [locationDetail, setLocationDetail] = useState(null);

  let navigate = useNavigate();
  useEffect(() => {
    if (!id) return;
    getUserDetail(id);
  }, [id]);
  const getUserDetail = async (id) => {
    setIsLoading(true);
    const query_parameters = {
      user_id: id,
    };
    const res = await getUserDetails(query_parameters);
    setUserDetails(res?.data?.result);
    sessionStorage.setItem("selectedDoctor", JSON.stringify(res?.data?.result));
    setIsLoading(false);
  };

  function convertTo12HourFormat(time) {
    const [hours, minutes] = time.split(":");
    const timeConvert = `2000-01-01T${time}:00Z`;
    const dummyDate = new Date(timeConvert)
    // const dummyDate = new Date(2000, 0, 1, hours, minutes);
    // console.log(dummyDate,'dummyDate',dateConvert(dummyDate))
    const formattedTime = format(dummyDate, "h:mm a");
    return formattedTime;
  }
  const StarRating = ({ rating, totalStars = 5 }) => {
    return (
      <div>
        {/* {[...Array(totalStars)].map((_, index) => (
          <Star key={index} selected={index < rating} />
        ))} */}
        <span style={{ color: "orange", fontSize: "20px" }}>&#9733;</span>
        <span className="px-2">{rating}</span>{" "}
        <span className="px-1">Rating</span>
      </div>
    );
  };

  const Star = ({ selected = false }) => (
    <span style={{ color: selected ? "orange" : "gray" }}>&#9733;</span>
  );
  const ScheduleDetails = (schedule) => {
    // Define the order of days
    const daysOrder = ["monday", "tuesday", "wednesday", "thursday", "friday"];

    // Sort the schedule based on the order of days
    const sortedSchedule = schedule?.sort((a, b) => {
      return (
        daysOrder.indexOf(a.day_of_week) - daysOrder.indexOf(b.day_of_week)
      );
    });

    return (
      <div className="">
        {sortedSchedule.map((day, index) => (
          <div
            key={index}
            className="p-2 bg-neutral-100 rounded-[18px] border my-3"
          >
            <div className="py-1 capitalize font-semibold">
              {day.day_of_week}
            </div>
            {day?.shifts?.map((shift, index) => (
              <div key={index} className="font-semibold">
                {convertTo12HourFormat(shift.shift_start)} -{" "}
                {convertTo12HourFormat(shift.shift_end)}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  const handleLocationChange = async (event) => {
    const location = event.target.value;
    setSelectedLocation(location);
  };

  useEffect(() => {
    const locationDetail = userDetails?.additional_details?.filter(
      (e) => e?.organization_details?.name == selectedLocation
    )[0];
    setLocationDetail(locationDetail);
    sessionStorage.setItem("selectedLocation", JSON.stringify(locationDetail));
  }, [selectedLocation]);

  useEffect(() => {
    if (userDetails) {
      const location =
        userDetails?.additional_details[0]?.organization_details?.name;
      setSelectedLocation(location);
    }
  }, [userDetails]);

  const gotoSchedule = () => {
    setSelectedAppointment({
      ...selectedAppointment,
      organization_id: locationDetail?.organization_details?.id,
    });
    navigate(
      `/scheduleAppointment/${locationDetail?.organization_details?.id}`
    );
  };

  return (
    <div className="bg-white min-sh-screen ">
      
      <div className="flex justify-between text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-white ">
        <div>
          <Link className="flex" to="/schedule">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
              />
            </svg>
            <div className="pl-2 flex-1 mt-0.5">
              <h4 className="font-semibold text-sm">Back</h4>
            </div>
          </Link>
        </div>
      </div>
      <div
        className=" flex-1 overflow-hidden hideScroll  text-gray-500  flex flex-col py-16 p-4 "
        // style={{ height: "calc(100svh - 4rem)" }}
      >
        {userDetails && !isLoading && (
          <>
            <div className="flex flex-col w-full  p-2 mt-1  shadow bg-[#F5F5F5] rounded-[18px] border">
              <div className="flex flex-row gap-4">
                <div className="w-[100px] h-[100px] rounded-full overflow-hidden">
                  {userDetails?.basic_details?.profile.avatar_url ? (
                    <img
                      className="w-full h-full object-cover"
                      src={userDetails?.basic_details?.profile.avatar_url}
                      alt={userDetails?.basic_details?.username}
                    />
                  ) : (
                    <img
                      className="w-full h-full object-cover"
                      src={"../../../images/user.svg"}
                      alt={userDetails?.basic_details?.username}
                    />
                  )}
                </div>
                <div className="flex flex-col">
                  <h1 className="text-lg font-bold">
                    {userDetails?.basic_details?.name_prefix}{" "}
                    {userDetails?.basic_details?.profile.first_name}{" "}
                    {userDetails?.basic_details?.profile.middle_name}{" "}
                    {userDetails?.basic_details?.profile.last_name}
                  </h1>

                  <div className="flex text-base">
                    {userDetails?.basic_details?.qualifications &&
                      userDetails?.basic_details?.qualifications.map(
                        (qualification, index) => (
                          <div key={index}>
                            <span
                              
                              className="text-neutral-500 text-sm font-normal"
                            >
                              {qualification}
                            </span>{" "}
                            {index <
                              userDetails?.basic_details?.qualifications
                                .length -
                                1 && <span className="pr-1">,</span>}
                          </div>
                        )
                      )}
                    {userDetails?.basic_details?.specialities &&
                      userDetails?.basic_details?.specialities.map(
                        (specialty, index) => (
                          <div key={index}>
                            <span className="pr-1">,</span>
                            <span
                              key={index}
                              className="text-neutral-500 text-sm font-normal"
                            >
                              {specialty?.name}
                            </span>{" "}
                            {index <
                              userDetails?.basic_details?.specialities.length -
                                1 && <span className="pr-1">,</span>}
                          </div>
                        )
                      )}
                  </div>

                  <StarRating rating={userDetails?.basic_details?.ratings} />
                </div>
              </div>
              <div className="w-full h-[0px] border-b-[1px] border-indigo-200 mb-2"></div>
              <div className="mt-4">
                <div className="font-semibold text-base">Overview</div>
                <div className=" ">
                  {" "}
                  <span className=" line-clamp-2 text-slate-700 text-base font-normal ">
                    {userDetails?.basic_details?.overview?.substring(0, 300)}
                  </span>
                  {/* <span className="text-blue-800 text-base font-bold ">More</span> */}
                </div>
              </div>
            </div>

            <div className=" relative pt-8 pb-1 ">
              <Tabs defaultValue="locations">
                <TabsList className="w-full  justify-start">
                  <TabsTrigger value="locations" className="flex-1">
                    Locations
                  </TabsTrigger>
                  <TabsTrigger value="profile" className="flex-1">
                    Profile
                  </TabsTrigger>
                </TabsList>

                <TabsContent value="locations">
                  <div
                    className=" flex-1 overflow-scroll hideScroll   flex flex-col "
                    style={{ height: "calc(100vh - 430px)" }}
                  >
                    <div id="location" className=" mt-2 scroll-item">
                      <div className="basecard-header">
                        <select
                          id="location"
                          className={cn(
                            "flex   h-14 w-full items-center justify-between rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm  placeholder:text-muted-foreground focus:outline-none  disabled:cursor-not-allowed disabled:opacity-50",
                            "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg "
                          )}
                          value={selectedLocation}
                          onChange={handleLocationChange}
                        >
                          {userDetails?.additional_details.map(
                            (location, index) => (
                              <option
                                key={index}
                                value={location?.organization_details?.name}
                                className=""
                              >
                                {location?.organization_details?.name}
                              </option>
                            )
                          )}
                        </select>
                      </div>

                      <div className="bg-white p-3  rounded shadow mt-1 ">
                        <div className="text-base font-semibold">
                          {locationDetail?.organization_details?.name}
                        </div>

                        <div className="">
                          <span className="pr-2">
                            {locationDetail?.organization_details?.location}{" "}
                          </span>
                          <span className="pr-2">
                            {
                              locationDetail?.organization_details?.address
                                ?.street
                            }
                            ,
                          </span>
                          <span className="pr-2">
                            {
                              locationDetail?.organization_details?.address
                                ?.city
                            }
                            ,
                          </span>
                          <span className="pr-2">
                            {
                              locationDetail?.organization_details?.address
                                ?.state
                            }
                          </span>

                          <span className="pr-2">
                            {
                              locationDetail?.organization_details?.address
                                ?.postal_code
                            }
                          </span>
                        </div>

                        {locationDetail?.organization_details?.contact?.filter(
                          (e) => e.type == "phone"
                        ).length > 0 && (
                          <div className="location-phone webmd-row">
                            Tel:{" "}
                            <a
                              href={`tel:${
                                locationDetail?.organization_details?.contact?.find(
                                  (contact) => contact.type === "phone"
                                )?.value
                              }`}
                              className=""
                            >
                              {
                                locationDetail?.organization_details?.contact?.find(
                                  (contact) => contact.type === "phone"
                                )?.value
                              }
                            </a>
                          </div>
                        )}
                        <div className="">
                          {locationDetail?.schedule_details &&
                            ScheduleDetails(locationDetail?.schedule_details)}
                        </div>
                      </div>
                    </div>
                  </div>
                </TabsContent>
                <TabsContent value="profile">
                  <div
                    className=" flex-1 overflow-scroll hideScroll   flex flex-col "
                    style={{ height: "calc(100vh - 430px)" }}
                  >
                    <div className="flex">
                      <h2 className="text-base font-semibold pb-2">
                        {" "}
                        OVERVIEW{" "}
                      </h2>
                    </div>
                    <div className="lhd-profile-bio">
                      {userDetails?.basic_details?.overview}
                    </div>
                    <div id="more" className="scroll-item">
                      <div className="bg-white p-3 my-2 rounded shadow">
                        <div className="">
                          <h2 className="text-base font-semibold pb-2">
                            SPECIALTIES
                          </h2>
                        </div>
                        <div className="basecard-content">
                          <div>
                            <ul className="conditions-list">
                              {userDetails?.basic_details?.specialities?.map(
                                (e, index) => (
                                  <li key={index} className="">
                                    {e.name}
                                  </li>
                                )
                              )}
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="bg-white p-3 my-2 rounded shadow">
                        <div className="">
                          <h2 className="text-base font-semibold pb-2">
                            PROCEDURES PERFORMED
                          </h2>
                        </div>
                        <div className="basecard-content">
                          <div>
                            <ul className="conditions-list">
                              <li>Physical Therapy</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="bg-white p-3 my-2 rounded shadow">
                        <div className="">
                          <h2 className="text-base font-semibold pb-2">
                            EDUCATION AND TRAINING
                          </h2>
                        </div>
                        {userDetails?.basic_details?.education_history?.map(
                          (e, index) => (
                            <div className="mb-2" key={index}>
                              <div className="font-semibold"> {e.details} </div>
                              <div className="">
                                <div className="font-medium">{e.name}</div>
                                <div className="text-gray-600">
                                  {" "}
                                  {e.degree}{" "}
                                </div>
                                <div className="text-gray-600">
                                  {" "}
                                  Graduated {e.graduation_year}{" "}
                                </div>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </TabsContent>
              </Tabs>

              {/* <button
                onClick={gotoSchedule}
                className={cn(
                  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
                  "bg-primary text-primary-foreground shadow hover:opacity-[.75]",
                  "w-full h-12 px-4 py-2"
                )}
              >
                Schedule appointment
              </button> */}
            </div>
          </>
        )}
        {isLoading && (
          <>
            <div className=" w-full bg-white p-2 mt-1 rounded shadow">
              <div className="animate-pulse flex flex-row cursor-pointer p-4 w-full  items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                <div className=" w-[80px] h-[80px] rounded-full flex-shrink-0  bg-slate-200"></div>
                <div className="flex flex-col w-full">
                  <div className="m-2 w-full  bg-slate-200 h-4"></div>
                  <div className="m-2  w-full  bg-slate-200 h-4"></div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="mb-4 text-xs border-b  mt-2 bg-white rounded shadow">
                <div className="animate-pulse flex flex-col cursor-pointer p-1 w-full justify-center items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                  <div className=" w-full  bg-slate-200 h-8"></div>
                </div>
              </div>

              <div
                className="overflow-scroll hideScroll flex flex-col gap-3"
                style={{ height: "calc(100vh - 250px)" }}
              >
                <div className="animate-pulse flex flex-col  cursor-pointer p-4 w-full justify-center items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                  <div className="m-2 w-full  bg-slate-200 h-4"></div>
                  <div className="m-2  w-full  bg-slate-200 h-4"></div>
                </div>
                <div className="animate-pulse flex flex-col cursor-pointer p-4 w-full justify-center items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                  <div className="m-2 w-full  bg-slate-200 h-4"></div>
                  <div className="m-2  w-full  bg-slate-200 h-4"></div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div
          className="bg-white h-16 fixed bottom-0 w-full flex justify-center"
          onClick={gotoSchedule}
        >
          <button className="  w-11/12 h-14 p-3 bg-blue-800 rounded-[18px] text-white font-semibold">
          Schedule appointment
          </button>
        </div>
    </div>
  );
};
